import { Link } from 'react-router-dom';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_trust-risk-scanner/artifacts/hba274xy_54B4EC9E-BB10-4795-9462-EE34138F48D0.png';

const Header = ({ showAdmin = false }) => {
  return (
    <header className="no-print fixed top-0 left-0 right-0 z-50 bg-[#0B0B0D]/90 backdrop-blur-md border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="header-logo">
          <img 
            src={LOGO_URL} 
            alt="Subsurface" 
            className="h-10 transition-transform group-hover:scale-105"
          />
        </Link>
        
        {showAdmin && (
          <Link 
            to="/admin" 
            className="text-sm text-muted-foreground hover:text-[#FF6A00] transition-colors font-medium"
            data-testid="admin-link"
          >
            Operator Dashboard
          </Link>
        )}
      </div>
    </header>
  );
};

export default Header;
